import { ChevronRight, Clear } from '@mui/icons-material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import {
    Box,
    Dialog,
    DialogActions,
    DialogContent,
    Divider,
    Grid,
    IconButton,
    Paper,
} from '@mui/material';
import { Button, Typography } from '@uhc-tempo/components';
import PropTypes from 'prop-types';
import React, { useContext, useEffect, useState, useRef } from 'react';
import useDetectMobile from '../../../utils/customHooks/useDetectMobile';
import { FormContext } from '../../../context/Form.context';
import { getPrice } from '../../../API/PriceService';
import { useHistory } from 'react-router-dom';
import { ERROR_ROUTE } from '../../../constants';
import displayLoadingIndicator from '../../../common/components/LoadingIndicator.components';

const OtherFacilitiesModal = (props) => {
    const { provider, dialogOpen, handleDialogClose, currentFacility, setCurrentFacility } = props;

    const {
        formValues,
        setSingleEstimateResponse,
        handleChangeCustom,
        memberDetails,
        sourceSystem,
        getIncrementedCorId,
        planBenefits,
        isPreventive,
    } = useContext(FormContext);

    const { selectedService } = formValues;

    const [otherFacilitiesDialog, setOtherFacilitiesDialog] = useState(false);

    const history = useHistory();

    const [loading, setLoading] = useState(false);

    const isEstimateScreen = true;

    const hasPreventive = selectedService?.value?.fullCarePath?.preventive;
    let nextIsPreventiveState = isPreventive;

    useEffect(() => {
        if (dialogOpen) {
            setOtherFacilitiesDialog(true);
        } else {
            setOtherFacilitiesDialog(false);
        }
    }, [dialogOpen]);

    useEffect(() => {
        if (otherFacilitiesDialog) {
            if (document.getElementById('otherFacilitiesDialogChildDiv')) {
                // Desktop View and Mobile View
                document.getElementById('otherFacilitiesDialogChildDiv').focus();
            }
        }
    }, [otherFacilitiesDialog]);

    const ref = useRef(null);
    const isDesktopView = useDetectMobile(ref);

    const handleModalClose = () => {
        handleDialogClose();
    };

    const handleViewingSingleProvider = () => {
        // this should pass setters and props here
        handleDialogClose();
    };

    const handleSetCurrentFacility = async (newFacilityIndex) => {
        setCurrentFacility(newFacilityIndex);
        handleDialogClose();
        setLoading(true);
        getSingleEstimate(provider, newFacilityIndex);
    };

    const renderAllLocations = () => {
        return provider?.facilitiesData?.length > 0
            ? provider.facilitiesData?.map((singleFacilityData, facilityIndex) => {
                  return renderLocationCard(singleFacilityData, facilityIndex);
              })
            : [];
    };

    const getSingleEstimate = async (providerData, facilityIndex) => {
        await getPrice(
            formValues,
            sourceSystem,
            [providerData],
            false,
            memberDetails,
            planBenefits,
            getIncrementedCorId(),
            false,
            hasPreventive ? nextIsPreventiveState : false,
            null,
            facilityIndex
        )
            .then((res) => {
                if (res instanceof Error) {
                    handleChangeCustom(null, 'selectedService');
                    handleChangeCustom(null, 'selectedProvider');
                    history.push(ERROR_ROUTE);
                    setLoading(false);
                    return;
                }
                setSingleEstimateResponse(res?.scenarios?.[0]);
                setLoading(false);
            })
            .catch((error) => {
                console.error('Error getting price', error);
                setSingleEstimateResponse(null);
            });
    };

    const renderAllLocationsMobile = () => {
        return provider?.facilitiesData?.length > 0
            ? provider.facilitiesData?.map((singleFacilityData, facilityIndex) => {
                  return renderLocationCardMobile(singleFacilityData, facilityIndex);
              })
            : [];
    };

    const renderLocationCardMobile = (location, index) => {
        return (
            <React.Fragment key={index}>
                <Grid
                    item
                    xs={12}
                    aria-label={`facilityCard${index}`}
                    label={`facilityCard${index}`}
                    key={location.locationId}
                    sx={{ paddingTop: '20px' }}
                >
                    <Grid container spacing={2.5} justifyContent="space-between" direction="column">
                        <Grid item>
                            <Paper
                                style={{
                                    borderRadius: '8px',
                                    border:
                                        currentFacility === index
                                            ? '4px solid rgba(25, 110, 207, 1)'
                                            : '0px',
                                    boxShadow: '0px 0px 6px rgba(0,0,0,0.2)',
                                }}
                                variant="outlined"
                                sx={{
                                    paddingX: '24px',
                                    paddingY: '24px',
                                }}
                            >
                                <Grid container justifyContent="space-between">
                                    <Typography.H4
                                        style={{
                                            marginBottom: '0px',
                                            fontWeight: 700,
                                        }}
                                    >
                                        {location.unTranslatedText}
                                    </Typography.H4>
                                    <Grid item xs={12}>
                                        <Typography.Paragraph
                                            style={{
                                                color: '#333333',
                                                fontWeight: '500',
                                                fontSize: '14.22px',
                                                marginBottom: '0px',
                                            }}
                                        >
                                            {location.locAndPractRole?.[0].specialties.join(', ')}
                                        </Typography.Paragraph>
                                        <Typography.Paragraph
                                            style={{
                                                color: '#333333',
                                                fontWeight: '500',
                                                fontSize: '14.22px',
                                                marginBottom: '0px',
                                            }}
                                        >
                                            {location.locAndPractRole?.[0].singleAddress.line[0]},{' '}
                                            {location.locAndPractRole?.[0].singleAddress.city},{' '}
                                            {location.locAndPractRole?.[0].singleAddress.state}{' '}
                                            {location.locAndPractRole?.[0].singleAddress.postalCode}
                                        </Typography.Paragraph>
                                    </Grid>
                                    <Grid item xs={12}>
                                        {currentFacility === index ? (
                                            <Grid container direction="column">
                                                <Grid item>
                                                    <Grid
                                                        container
                                                        alignItems="center"
                                                        direction="row"
                                                    >
                                                        <CheckCircleIcon
                                                            style={{
                                                                color: '#196ECF',
                                                                height: '16px',
                                                                width: '16px',
                                                                marginRight: '8px',
                                                            }}
                                                        />
                                                        <Typography.Paragraph
                                                            style={{
                                                                color: '#333333',
                                                                marginBottom: '0px',
                                                                fontWeight: '400',
                                                                fontSize: '14.22px',
                                                            }}
                                                        >
                                                            This facility is currently selected
                                                        </Typography.Paragraph>
                                                    </Grid>
                                                </Grid>
                                                <Grid item sx={{ marginTop: '13px' }}>
                                                    <Grid
                                                        container
                                                        alignItems="center"
                                                        direction="row"
                                                    >
                                                        <Typography.Paragraph
                                                            onClick={handleViewingSingleProvider}
                                                            onKeyDown={(e) => {
                                                                if (e.key == 'Enter') {
                                                                    handleViewingSingleProvider();
                                                                }
                                                            }}
                                                            tabIndex="0"
                                                            style={{
                                                                color: '#196ECF',
                                                                fontWeight: '700',
                                                                fontSize: '12.64px',
                                                                marginBottom: '0px',
                                                                cursor: 'pointer',
                                                            }}
                                                        >
                                                            View Estimate
                                                        </Typography.Paragraph>
                                                        <ChevronRight
                                                            style={{
                                                                color: '#196ECF',
                                                                height: '16px',
                                                                width: '16px',
                                                                cursor: 'pointer',
                                                            }}
                                                        />
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        ) : (
                                            <Grid
                                                container
                                                alignItems="center"
                                                direction="row"
                                                sx={{ marginTop: '13px' }}
                                            >
                                                <Typography.Paragraph
                                                    onClick={() => {
                                                        handleSetCurrentFacility(index);
                                                    }}
                                                    onKeyDown={(e) => {
                                                        if (e.key == 'Enter') {
                                                            handleSetCurrentFacility(index);
                                                        }
                                                    }}
                                                    tabIndex="0"
                                                    style={{
                                                        color: '#196ECF',
                                                        fontWeight: '700',
                                                        fontSize: '12.64px',
                                                        marginBottom: '0px',
                                                        cursor: 'pointer',
                                                    }}
                                                >
                                                    Use this facility and view estimate
                                                </Typography.Paragraph>
                                                <ChevronRight
                                                    style={{
                                                        color: '#196ECF',
                                                        height: '16px',
                                                        width: '16px',
                                                        cursor: 'pointer',
                                                    }}
                                                />
                                            </Grid>
                                        )}
                                    </Grid>
                                </Grid>
                            </Paper>
                        </Grid>
                    </Grid>
                </Grid>
            </React.Fragment>
        );
    };

    const renderLocationCard = (location, index) => {
        return (
            <React.Fragment key={index}>
                {index % 3 === 0 && index !== 0 && (
                    <Grid item xs={12}>
                        <Divider orientation="horizontal" />
                    </Grid>
                )}
                <Grid
                    item
                    xs={4}
                    aria-label={`facilityCard${index}`}
                    label={`facilityCard${index}`}
                    key={location.locationId}
                >
                    <Grid
                        container
                        spacing={0}
                        justifyContent="space-between"
                        direction="row"
                        sx={{ height: '100%' }}
                    >
                        {(index - 1) % 3 === 0 ? (
                            <Grid item style={{ marginTop: '24px', marginBottom: '24px' }}>
                                <Divider orientation="vertical" />
                            </Grid>
                        ) : (
                            index === 1 && (
                                <Grid item style={{ marginTop: '24px', marginBottom: '24px' }}>
                                    <Divider orientation="vertical" />
                                </Grid>
                            )
                        )}
                        <Grid item xs={(index - 1) % 3 === 0 ? 11.9 : index === 1 ? 11.9 : 12}>
                            <Paper
                                style={{
                                    borderRadius: '8px',
                                    border:
                                        currentFacility === index
                                            ? '4px solid rgba(25, 110, 207, 1)'
                                            : '0px',
                                }}
                                variant="outlined"
                                sx={{
                                    paddingX: '24px',
                                    paddingY: '24px',
                                }}
                            >
                                <Grid container justifyContent="space-between">
                                    <Typography.H4
                                        style={{
                                            marginBottom: '0px',
                                            fontWeight: 700,
                                        }}
                                    >
                                        {location.unTranslatedText}
                                    </Typography.H4>
                                    <Grid item xs={12}>
                                        <Typography.Paragraph
                                            style={{
                                                color: '#333333',
                                                fontWeight: '500',
                                                fontSize: '14.22px',
                                                marginBottom: '0px',
                                            }}
                                        >
                                            {location.locAndPractRole?.[0].specialties.join(', ')}
                                        </Typography.Paragraph>
                                        <Typography.Paragraph
                                            style={{
                                                color: '#333333',
                                                fontWeight: '500',
                                                fontSize: '14.22px',
                                                marginBottom: '0px',
                                            }}
                                        >
                                            {location.locAndPractRole?.[0].singleAddress.line[0]},{' '}
                                            {location.locAndPractRole?.[0].singleAddress.city},{' '}
                                            {location.locAndPractRole?.[0].singleAddress.state}{' '}
                                            {location.locAndPractRole?.[0].singleAddress.postalCode}
                                        </Typography.Paragraph>
                                    </Grid>
                                    <Grid item xs={12}>
                                        {currentFacility === index ? (
                                            <Grid container direction="column">
                                                <Grid item>
                                                    <Grid
                                                        container
                                                        alignItems="center"
                                                        direction="row"
                                                    >
                                                        <CheckCircleIcon
                                                            style={{
                                                                color: '#196ECF',
                                                                height: '16px',
                                                                width: '16px',
                                                                marginRight: '8px',
                                                            }}
                                                        />
                                                        <Typography.Paragraph
                                                            style={{
                                                                color: '#333333',
                                                                marginBottom: '0px',
                                                                fontWeight: '400',
                                                                fontSize: '14.22px',
                                                            }}
                                                        >
                                                            This facility is currently selected
                                                        </Typography.Paragraph>
                                                    </Grid>
                                                </Grid>
                                                <Grid item sx={{ marginTop: '13px' }}>
                                                    <Grid
                                                        container
                                                        alignItems="center"
                                                        direction="row"
                                                    >
                                                        <Typography.Paragraph
                                                            onClick={handleDialogClose}
                                                            onKeyDown={(e) => {
                                                                if (e.key == 'Enter') {
                                                                    handleDialogClose();
                                                                }
                                                            }}
                                                            tabIndex="0"
                                                            style={{
                                                                color: '#196ECF',
                                                                fontWeight: '700',
                                                                fontSize: '12.64px',
                                                                marginBottom: '0px',
                                                                cursor: 'pointer',
                                                            }}
                                                        >
                                                            View Estimate
                                                        </Typography.Paragraph>
                                                        <ChevronRight
                                                            style={{
                                                                color: '#196ECF',
                                                                height: '16px',
                                                                width: '16px',
                                                                cursor: 'pointer',
                                                            }}
                                                        />
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        ) : (
                                            <Grid
                                                container
                                                alignItems="center"
                                                direction="row"
                                                sx={{ marginTop: '13px' }}
                                            >
                                                <Typography.Paragraph
                                                    onClick={() => {
                                                        handleSetCurrentFacility(index);
                                                    }}
                                                    onKeyDown={(e) => {
                                                        if (e.key == 'Enter') {
                                                            handleSetCurrentFacility(index);
                                                        }
                                                    }}
                                                    tabIndex="0"
                                                    style={{
                                                        color: '#196ECF',
                                                        fontWeight: '700',
                                                        fontSize: '12.64px',
                                                        marginBottom: '0px',
                                                        cursor: 'pointer',
                                                    }}
                                                >
                                                    Use this facility and view estimate
                                                </Typography.Paragraph>
                                                <ChevronRight
                                                    style={{
                                                        color: '#196ECF',
                                                        height: '16px',
                                                        width: '16px',
                                                        cursor: 'pointer',
                                                    }}
                                                />
                                            </Grid>
                                        )}
                                    </Grid>
                                </Grid>
                            </Paper>
                        </Grid>
                        {(index - 1) % 3 === 0 ? (
                            <Grid item style={{ marginTop: '24px', marginBottom: '24px' }}>
                                <Divider orientation="vertical" />
                            </Grid>
                        ) : (
                            index === 1 && (
                                <Grid item style={{ marginTop: '24px', marginBottom: '24px' }}>
                                    <Divider orientation="vertical" />
                                </Grid>
                            )
                        )}
                    </Grid>
                </Grid>
            </React.Fragment>
        );
    };

    return (
        <Box sx={{ width: '100%' }} data-testid="facilitiesPage">
            {loading ? (
                displayLoadingIndicator(isEstimateScreen)
            ) : (
                <div aria-label="dialogModalContainer" ref={ref}>
                    <Dialog
                        fullWidth
                        maxWidth="lg"
                        open={dialogOpen}
                        onClose={handleDialogClose}
                        data-testid="otherFacilitiesWindow"
                        id="otherFacilities-dialog"
                        fullScreen={!isDesktopView}
                        PaperProps={{
                            tabIndex: -1,
                            id: 'otherFacilitiesDialogChildDiv',
                            'aria-labelledby': 'facilityHeaderName',
                        }}
                    >
                        <Grid
                            container
                            direction="row"
                            justify="space-between"
                            alignItems="flex-start"
                            style={{
                                paddingLeft: '24px',
                                paddingRight: '24px',
                                paddingBottom: '0px',
                            }}
                        >
                            <Grid item xs={10}>
                                {isDesktopView ? (
                                    <Typography.H4
                                        style={{
                                            marginBottom: '0px',
                                            paddingTop: '20px',
                                            fontWeight: 700,
                                        }}
                                        id="facilityHeaderName"
                                        data-testid="facilityName"
                                    >
                                        Change Facility
                                    </Typography.H4>
                                ) : (
                                    <Typography.H4
                                        style={{
                                            marginBottom: '0px',
                                            paddingTop: '17px',
                                            fontWeight: 700,
                                        }}
                                        id="facilityHeaderName"
                                        data-testid="facilityName"
                                    >
                                        Change Facility
                                    </Typography.H4>
                                )}
                            </Grid>
                            {/* Used for mobile view */}
                            <Grid item xs={2} hidden={isDesktopView}>
                                <IconButton
                                    title="exit"
                                    onClick={handleModalClose}
                                    aria-label="Close other facilities dialog"
                                    data-testid="closeOtherFacilitiesDialogMobile"
                                    style={{ float: 'right' }}
                                >
                                    <Clear />
                                </IconButton>
                            </Grid>

                            <Grid
                                item
                                xs={2}
                                textAlign="right"
                                hidden={!isDesktopView}
                                style={{ paddingTop: '25px' }}
                            >
                                <IconButton
                                    title="exit"
                                    onClick={handleModalClose}
                                    data-testid="closeOtherFacilitiesDialog"
                                    aria-label="Close other facilities dialog"
                                >
                                    <Clear />
                                </IconButton>
                            </Grid>
                            <Grid item xs={10}>
                                <Grid container direction="row">
                                    <Typography.Paragraph
                                        style={{
                                            color: '#333333',
                                            marginBottom: '16px',
                                            fontSize: '14.22px',
                                            fontWeight: 700,
                                        }}
                                    >
                                        {`${
                                            provider?.facilitiesData?.length
                                                ? provider.facilitiesData?.length
                                                : 1
                                        } facilities`}
                                    </Typography.Paragraph>
                                    <Typography.Paragraph
                                        style={{
                                            color: '#333333',
                                            marginBottom: '16px',
                                            fontSize: '14.22px',
                                            marginLeft: '4px',
                                        }}
                                    >
                                        for this procedure
                                    </Typography.Paragraph>
                                </Grid>
                            </Grid>
                            <Grid item xs={12}>
                                <Divider aria-hidden="true" role="presentation" />
                            </Grid>
                        </Grid>

                        <DialogContent aria-label="facilitiesList">
                            <Grid container>
                                {isDesktopView ? renderAllLocations() : renderAllLocationsMobile()}
                            </Grid>
                        </DialogContent>
                        <DialogActions
                            aria-label="otherFacilitiesActions"
                            style={{
                                paddingTop: '32px',
                                paddingLeft: '24px',
                                paddingRight: '24px',
                                paddingBottom: '32px',
                            }}
                        >
                            <Grid container alignItems="center" justify="flext-start">
                                <Grid item hidden={!isDesktopView}>
                                    <Button
                                        aria-label="closeFacilitiesWindowButtonMapView"
                                        variant="contained"
                                        color="primary"
                                        onClick={handleDialogClose}
                                    >
                                        Close
                                    </Button>
                                </Grid>
                            </Grid>
                        </DialogActions>
                    </Dialog>
                </div>
            )}
        </Box>
    );
};

OtherFacilitiesModal.propTypes = {
    dialogOpen: PropTypes.bool.isRequired,
    handleDialogClose: PropTypes.func.isRequired,
};

OtherFacilitiesModal.defaultProps = {
    dialogOpen: false,
};

export default OtherFacilitiesModal;
